import React, { useState, useEffect, useContext } from 'react';
import MaterialTable from 'material-table';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import GenericDialogBox from '../../components/GenericDialogBox';
import InfoBox from '../../components/InfoBox';
import DataService from "../../services/data.service";
import { useTranslation } from "react-i18next";
import PermissionContext from '../../contexts/PermissionContext';
import currency from 'currency.js'

const currFormat = { decimal: ',', symbol: '', separator: '.' }

const useStyles = makeStyles((theme) => ({
	paper: {
		marginTop: theme.spacing(18),
		maxWidth: 800,
		margin: 'auto',
		overflow: 'hidden',
		backgroundColor: 'white'
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {

		margin: theme.spacing(3, 2, 2),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
}));




const DetailForm = (props) => {

	const getData = props.getData;
	const { invoiceId, setInvoiceId, productData, setProductData, permission } = props

	const {userHasPermission} = useContext(PermissionContext)
  
	// console.log("UHP",userHasPermission)
	
	let hasPerm = userHasPermission(permission, 'can_list')
	let hasAddPerm = userHasPermission(permission, 'can_post')
	let hasEditPerm = userHasPermission(permission, 'can_patch')
	let hasGetPerm = userHasPermission(permission, 'can_get')
	let hasDeletePerm = userHasPermission(permission, 'can_delete')
	// for detail form    
	let hasDeleteDetailPerm = userHasPermission(`${permission}-detail`, 'can_delete')


	const [qtty, setQtty] = useState(1)
	const [price, setPrice] = useState(0.00)
	const openNoticeBox = props.openNoticeBox
	const { t } = useTranslation();

	const [productValue, setProductValue] = React.useState("-");
	const [productInputValue, setProductInputValue] = React.useState('');

	//autofocus thingy
	// const nextfield = document.querySelector(
	// 	`input[id=product]`
	// );
	// console.log("next", nextfield)
	// // If found, focus the next field
	// if (nextfield !== null) {
	// 	nextfield.focus();
	// }
	const moveToFirst = () => {
		//autofocus thingy place at the first field after adding
		const nextfield = document.querySelector(
			`input[id=product]`
		);
		// If found, focus the next field
		if (nextfield !== null) {
			nextfield.focus();
		}
	}

	const addData = (values) => {
		DataService.create(`${endpoint}/`, values)
			.then(response => {
				// openNoticeBox("Notice", "Invoice created successfully")   			
				// setInvoiceId(response.data.id)
				// setData(emptyData)
				getData(invoiceId)				
			})
			.catch(e => {
				openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
				
			});

	}

	const AddDetail = (event) => {
		event.preventDefault();
		if (typeof productValue === 'undefined') {
			openNoticeBox("Error", t("should_pick_a_product"))
			return false
		}
		let values = {
			'invoice_id': invoiceId,
			'product_id': productValue.id,
			'qtty': qtty,
			'price': price,
		}
		//  console.log(values)					
		addData(values)
		moveToFirst()
	}

	return (
		<Grid container spacing={1}>
			<Grid item xs={12}>
				<Typography variant="h6" component="h6">
					Detail:
				</Typography>
			</Grid>

			<Grid item xs={4}>
				<Autocomplete
					id="product"
					name="product"
					// value={value}
					options={productData}
					getOptionLabel={(option) => option.name ? option.name : "-"}
					onChange={(event, newValue) => {
						setProductValue(newValue);
						setPrice(newValue.price)
					}}
					inputValue={productInputValue}
					onInputChange={(event, newInputValue) => {
						setProductInputValue(newInputValue);
						setPrice(newInputValue.price)
					}}

					value={productValue ? productValue : ""}
					renderInput={(params) => <TextField {...params} label={t("invoice_form_detail_lbl_product")} />}
					disabled={invoiceId === 0 ? true : false}
					getOptionSelected={(option, value) => option.value === value.value}
					onKeyPress={event => {
						const { key } = event;
						if (key === "Enter") {							
							const nextfield = document.querySelector(
								`input[id=qtty]`
							);
							if (nextfield !== null) {
								nextfield.focus();
								event.preventDefault();
							}

							// If found, focus the next field							
						}
					}
					}

				/>
			</Grid>
			<Grid item xs={2}>
				<TextField
					margin="normal"
					fullWidth
					id="qtty"
					label={t("invoice_form_detail_lbl_qtty")}
					name="qtty"
					onChange={event => setQtty(event.target.value)}
					value={qtty}
					style={{ marginTop: '-1px' }}
					disabled={invoiceId === 0 ? true : false}
					onKeyPress={event => {
						const { key } = event;
						if (key === "Enter") {							
							const nextfield = document.querySelector(
								`input[id=price]`
							);
							// If found, focus the next field
							if (nextfield !== null) {
								nextfield.focus();
								event.preventDefault();
							}
						}
					}
					}
				/>
			</Grid>
			<Grid item xs={2}>
				<TextField
					margin="normal"
					fullWidth
					id="price"
					label={t("invoice_form_detail_lbl_price")}
					name="price"
					onChange={event => setPrice(event.target.value)}
					value={price ? price : 0}
					style={{ marginTop: '-1px' }}
					disabled={invoiceId === 0 ? true : false}
					onKeyPress={event => {
						const { key } = event;
						if (key === "Enter") {
							const nextfield = document.querySelector(
								`button[id=add]`
							);
							// If found, focus the next field
							if (nextfield !== null) {
								nextfield.focus();
							}
							event.preventDefault();
						}
					}
					}
				/>
			</Grid>
			<Grid item xs={2}>
				<TextField
					margin="normal"
					fullWidth
					id="total"
					label={t("invoice_form_detail_lbl_total")}
					name="total"
					disabled
					// onChange={event => { }}
					value={price * qtty ? price * qtty : 0.00}
					style={{ marginTop: '-1px' }}
				/>
			</Grid>
			<Grid item xs={2}>
				<Fab color="default" size="small" id="add" aria-label="add" onClick={AddDetail} style={{ marginTop: '-5px' }} 
					disabled={invoiceId === 0 ? true : !hasAddPerm ? true : false} 
					>
					<AddIcon />
				</Fab>
			</Grid>
		</Grid>
	)
}


const endpoint = `invoice-detail`
const invoiceEndpoint = `invoice`


const DetailTable = (props) => {
	const { t } = useTranslation();

	const { invoiceId, setInvoiceId, dctValue, taxValue, productData, setProductData, getInvoiceData, permission } = props

	const {userHasPermission} = useContext(PermissionContext)
  
	// console.log("UHP",userHasPermission)
	
	let hasPerm = userHasPermission(permission, 'can_list')
	let hasAddPerm = userHasPermission(permission, 'can_post')
	let hasEditPerm = userHasPermission(permission, 'can_patch')
	let hasGetPerm = userHasPermission(permission, 'can_get')
	let hasDeletePerm = userHasPermission(permission, 'can_delete')
	// for detail form    
	let hasDeleteDetailPerm = userHasPermission(`${permission}-detail`, 'can_delete')



	const [detailSubTotal, setDetailSubTotal] = useState("0.00")

	const [detailDctTotal, setDetailDctTotal] = useState("0.00")
	useEffect(() => {
		setDetailDctTotal(detailSubTotal * (dctValue / 100))
	}, [dctValue, detailSubTotal]);

	const [detailTaxTotal, setDetailTaxTotal] = useState("0.00")
	useEffect(() => {
		let tmpdct = detailSubTotal * (dctValue / 100)
		setDetailTaxTotal((detailSubTotal - tmpdct) * (taxValue / 100))
	}, [taxValue, detailSubTotal]);

	const [detailTotal, setDetailTotal] = useState("0.00")
	useEffect(() => {
		// console.log(detailSubTotal,detailDctTotal,detailTaxTotal)
		let tmpdct = detailSubTotal * (dctValue / 100)
		let tmptax = (detailSubTotal - tmpdct) * (taxValue / 100)
		setDetailTotal(detailSubTotal - tmpdct + tmptax)
	}, [taxValue, dctValue, detailSubTotal]);

	const [showForm, setShowForm] = useState(false);

	const classes = useStyles();

	// INFO NOTIFICATION VARS
	const [infoOpen, setInfoOpen] = useState(false);
	const [infoTitle, setInfoTitle] = useState('');
	const [infoBody, setInfoBody] = useState('');
	//***********************

	//Dialog Vars
	const [dialogOpen, setDialogOpen] = useState(false);
	const [dialogueTitle, setDialogueTitle] = useState('');
	const [dialogueBody, setDialogueBody] = useState('');
	//**********

	// DIALOG FUNCTIONS 
	const handleDialogOk = () => {
		setDialogOpen(false)
	};

	const handleDialogClose = () => {
		setDialogOpen(false)
	};

	const openDialogBox = (title, body) => {
		setDialogueTitle(title)
		setDialogueBody(body)
		setDialogOpen(true)
	};
	//*******************

	// Notification INFO functions
	const openNoticeBox = (title, body) => {
		setInfoTitle(title)
		setInfoBody(body)
		setInfoOpen(true)
	};

	const handleInfoClose = () => {
		setInfoOpen(false)
	};
	// *****************


	const [detailData, setDetailData] = useState([]);
	useEffect(() => {
		getData(invoiceId)
	}, []);

	const getData = (id) => {
		DataService.get(id, endpoint)
			.then(response => {
				// console.log("get data", response.data)
				setDetailData(response.data)
				var sumdetail = 0;
				response.data.forEach(function (record) {
					sumdetail += record.total;
				});
				setDetailSubTotal(sumdetail)
				getInvoiceData(invoiceId)
			})
			.catch(e => {
				if (e.response.status !== '404') {
					openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
					// setData(emptyData)
				} else {
					// setData(emptyData)
					console.log("")
				}

			});
	}

	const deleteDetail = (id) => {
		var dataDelete = { 'id': id };
		DataService.delete(endpoint, dataDelete)
			.then(response => {
				// openNoticeBox("Notice", "Invoice deleted successfully")   
				getData(invoiceId)
			})
			.catch(e => {
				openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
			});
	}


	return (
		<Grid container spacing={2}>
			<GenericDialogBox
				opn={dialogOpen}
				handleDialogOk={handleDialogOk}
				handleDialogClose={handleDialogClose}
				title={dialogueTitle}
				body={dialogueBody} />
			<InfoBox
				opn={infoOpen}
				handleDialogClose={handleInfoClose}
				title={infoTitle}
				body={infoBody} />

			<MaterialTable
				title="Detail"
				columns={[
					{ title: 'ID', field: 'id',width: "5%"  },
					{ title: t("invoice_form_detail_product"), field: 'product.name', width: "70%" },
					{ title: t("invoice_form_detail_qtty"), field: 'qtty', width: "5%" , render: rowData => rowData.qtty.toFixed(2) },
					{ title: t("invoice_form_detail_price"), field: 'price', width: "5%" , render: rowData => rowData.price.toFixed(2) },
					{ title: t("invoice_form_detail_total"), field: 'total' , width: "5%", render: rowData => rowData.total.toFixed(2) }
				]}				
				data={detailData}
				actions={[					
					rowData => ({
						icon: 'delete',
						tooltip: t("detail_delete_record_tip"),
						onClick: (event, rowData) => deleteDetail(rowData.id),
						disabled:  !hasDeletePerm
					  }),
				]}
				options={{
					actionsColumnIndex: -1,
					search: false,
					paging: false,
					tableLayout: 'auto'
					
				}}
				components={{
					Toolbar: props => (
						<div style={{ backgroundColor: '#e8eaf5' }}>
							<DetailForm
								invoiceId={invoiceId}
								openNoticeBox={openNoticeBox}
								getData={getData}
								productData={productData}
								setProductData={setProductData}
								permission={permission}
							/>
						</div>
					)
				}}
			/>
			<div style={{ align: 'right', width: '500px', textAlignLast: 'right' }}>
				<Typography variant="h6" component="h6">					
					Subtotal: {currency(detailSubTotal,currFormat).format()}
				</Typography>
				<Typography variant="h6" component="h6">
					Discount ({parseFloat(dctValue).toFixed(2)}): {parseFloat(detailDctTotal).toFixed(2)}
				</Typography>
				<Typography variant="h6" component="h6">
					Tax ({parseFloat(taxValue).toFixed(2)}): {parseFloat(detailTaxTotal).toFixed(2)}
				</Typography>
				<Typography variant="h5" component="h5">
					Total: {currency(detailTotal, currFormat).format()}					
				</Typography>
			</div>
		</Grid>
	)
}

export default DetailTable;